import { IState } from 'shared/store';

export function selectNewbuildingKpnChatEnabled(state: IState): boolean {
  const isFlagEnabled = state.rs.kpnChat.enabled;
  // Проверяет условие по региону и ЖК
  const isKpnChatEnabled = state.offerData.offer.kpnChatEnabled || false;

  return isFlagEnabled && isKpnChatEnabled;
}
